export class SiteHours extends HTMLElement {
  constructor(data=null, index=Date.now()) {
    super();
    this.data = data;
    this.index = index;
  }

  connectedCallback() {
    this.innerHTML = `
      <style>
        .remove_site_hours_range {
          float:right;
        }
        site-hours {
          margin-bottom: 15px;
          display: block;
        }
      </style>
      ${this.data != null ? `<input type="hidden" name="domain[site_attributes][sites_chat_hours_attributes][${this.index}][id]" value="${this.data.site_chat_hours_id}"/>` : ""}
      ${this.data != null ? `<input type="hidden" name="domain[site_attributes][sites_chat_hours_attributes][${this.index}][_destroy]" value="false"/>` : ""}
      <div class="row site_chat_hours form-group">
        <div class="col-lg-3">
          <select name="domain[site_attributes][sites_chat_hours_attributes][${this.index}][day_map]" class="form-control">
            <option value="127">Any Day</option>
            <option value="62">Weekdays</option>
            <option value="65">Weekends</option>
            <option value="2">Monday</option>
            <option value="4">Tuesday</option>
            <option value="8">Wednesday</option>
            <option value="16">Thursday</option>
            <option value="32">Friday</option>
            <option value="64">Saturday</option>
            <option value="1">Sunday</option>
          </select>
        </div>
        <div class="col-lg-9">
          <select name="site_range_type" class="form-control" style="width:auto; display: inline;">
            <option value="0">Between</option>
            <option class="all_day" value="1" checked="true">All Day</option>
          </select>
          <div class="times" style="width:auto; display: inline;">
            <select name="site_start_hour" class="form-control" style="width:auto; display: inline;">
              <option checked="" value="00">12 AM</option>
              <option value="01">1 AM</option>
              <option value="02">2 AM</option>
              <option value="03">3 AM</option>
              <option value="04">4 AM</option>
              <option value="05">5 AM</option>
              <option value="06">6 AM</option>
              <option value="07">7 AM</option>
              <option value="08">8 AM</option>
              <option value="09">9 AM</option>
              <option value="10">10 AM</option>
              <option value="11">11 AM</option>
              <option value="12">12 PM</option>
              <option value="13">1 PM</option>
              <option value="14">2 PM</option>
              <option value="15">3 PM</option>
              <option value="16">4 PM</option>
              <option value="17">5 PM</option>
              <option value="18">6 PM</option>
              <option value="19">7 PM</option>
              <option value="20">8 PM</option>
              <option value="21">9 PM</option>
              <option value="22">10 PM</option>
              <option value="23">11 PM</option>
            </select>
            :
            <select name="site_start_minute" class="form-control" style="width:auto;display: inline;">
              <option>00</option>
              <option>05</option>
              <option>10</option>
              <option>15</option>
              <option>20</option>
              <option>25</option>
              <option>30</option>
              <option>35</option>
              <option>40</option>
              <option>45</option>
              <option>50</option>
              <option>55</option>
            </select>
            &amp;
            <select name="site_end_hour" class="form-control" style="width:auto;display: inline;">
              <option checked="" value="00">12 AM</option>
              <option value="01">1 AM</option>
              <option value="02">2 AM</option>
              <option value="03">3 AM</option>
              <option value="04">4 AM</option>
              <option value="05">5 AM</option>
              <option value="06">6 AM</option>
              <option value="07">7 AM</option>
              <option value="08">8 AM</option>
              <option value="09">9 AM</option>
              <option value="10">10 AM</option>
              <option value="11">11 AM</option>
              <option value="12">12 PM</option>
              <option value="13">1 PM</option>
              <option value="14">2 PM</option>
              <option value="15">3 PM</option>
              <option value="16">4 PM</option>
              <option value="17">5 PM</option>
              <option value="18">6 PM</option>
              <option value="19">7 PM</option>
              <option value="20">8 PM</option>
              <option value="21">9 PM</option>
              <option value="22">10 PM</option>
              <option value="23">11 PM</option>
            </select>
            :
            <select name="site_end_minute" class="form-control" style="width:auto;display: inline;">
              <option>00</option>
              <option>05</option>
              <option>10</option>
              <option>15</option>
              <option>20</option>
              <option>25</option>
              <option>30</option>
              <option>35</option>
              <option>40</option>
              <option>45</option>
              <option>50</option>
              <option>55</option>
            </select>
          </div>
          <div style="width:auto;display: inline;">
            <a href="#" class="remove_site_hours_range btn btn-outline-warning" style="margin-left: 10px;">Remove</a>
          </div>
        </div>

          <input type="hidden" name="domain[site_attributes][sites_chat_hours_attributes][${this.index}][start_time]" value="0000"/>
          <input type="hidden" name="domain[site_attributes][sites_chat_hours_attributes][${this.index}][end_time]" value="0000"/>

          
        
      </div>
    `

    // Elements
    this.day_map = this.querySelector(`select[name='domain[site_attributes][sites_chat_hours_attributes][${this.index}][day_map]']`);
    
    this.range_type = this.querySelector(`select[name=site_range_type]`)

    this.start_time = this.querySelector(`input[name='domain[site_attributes][sites_chat_hours_attributes][${this.index}][start_time]']`)
    this.start_hour = this.querySelector(`select[name=site_start_hour]`);
    this.start_minute = this.querySelector(`select[name=site_start_minute]`);
    
    this.end_hour = this.querySelector(`select[name=site_end_hour]`);
    this.end_minute = this.querySelector(`select[name=site_end_minute]`);
    this.end_time = this.querySelector(`input[name='domain[site_attributes][sites_chat_hours_attributes][${this.index}][end_time]']`)

    if(this.data) {
      // day(s) of week
      this.day_map.value = this.data.day_map;

      if(this.data.start_time == "0000" && this.data.end_time == "2400") {
        this.range_type.value = '1';
      } else {
        this.range_type.value = '0';
        // start time
        this.start_hour.value = this.data.start_time.slice(0,2);
        this.start_minute.value = this.data.start_time.slice(2,4);
        // end time
        this.end_hour.value = this.data.end_time.slice(0,2);
        this.end_minute.value = this.data.end_time.slice(2,4);
      } 
    } else {
      this.range_type.value = '1';
    }
    this.showTimes();
    this.updateTimes();

    this.createListeners();
  }

  createListeners() {
    this.querySelector(".remove_site_hours_range").addEventListener("click", function(e) {
      e.preventDefault();
      this.querySelector(".site_chat_hours").remove();
      if(this.data != null) {
        this.querySelector(`input[name="domain[site_attributes][sites_chat_hours_attributes][${this.index}][_destroy]"]`).value = true
      }
    }.bind(this));

    this.range_type.addEventListener("change", function() {
      this.showTimes();
      this.updateTimes();
    }.bind(this));
    this.start_hour.addEventListener("change", function() {
      this.updateTimes();
    }.bind(this));
    this.start_minute.addEventListener("change", function() {
      this.updateTimes();
    }.bind(this));
    this.end_hour.addEventListener("change", function() {
      this.updateTimes();
    }.bind(this));
    this.end_minute.addEventListener("change", function() {
      this.updateTimes();
    }.bind(this));
  }

  updateTimes() {
    if(this.range_type.value == '1') {
      // start time
      this.start_time.value = `0000`;
      // end time
      this.end_time.value = `2400`;
    } else {
      // start time
      this.start_time.value = `${this.start_hour.value}${this.start_minute.value}`;
      // end time
      this.end_time.value = `${this.end_hour.value}${this.end_minute.value}`;
    }
  }

  showTimes() {
    let visible = this.range_type.value != '1';
    this.querySelector(".times").style.display = visible ? 'inline-block' : 'none';
  }

  validate() {
    return Number(this.start_time.value) < Number(this.end_time.value);
  }
}

customElements.define("site-hours", SiteHours)